var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dt',{staticClass:"gl-text-strong"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('dd',{staticClass:"gl-mb-0 gl-break-anywhere"},[(_vm.glSlots().default)?[_vm._t("default")]:(_vm.value)?[_vm._v("\n      "+_vm._s(_vm.value)+"\n    ")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }